/* eslint-disable import/prefer-default-export */

export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const SET_LOCALE_START = 'SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';
export const FETCH_CONTENT_START = 'FETCH_CONTENT_START';
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_ERROR = 'FETCH_CONTENT_ERROR';
export const LOAD_USER_DATA = 'LOAD_USER_DATA';

// Load User Account Data
export const SET_USER_DATA_START = 'SET_USER_DATA_START';
export const SET_USER_DATA_SUCCESS = 'SET_USER_DATA_SUCCESS';
export const SET_USER_DATA_ERROR = 'SET_USER_DATA_ERROR';

// Delete Blog Details
export const ADMIN_DELETE_BlOGDETAILS_START = 'ADMIN_DELETE_BlOGDETAILS_START';
export const ADMIN_DELETE_BlOGDETAILS_SUCCESS =
  'ADMIN_DELETE_BlOGDETAILS_SUCCESS';
export const ADMIN_DELETE_BlOGDETAILS_ERROR = 'ADMIN_DELETE_BlOGDETAILS_ERROR';

// Logout
export const USER_LOGOUT_START = 'USER_LOGOUT_START';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_ERROR = 'USER_LOGOUT_ERROR';

// Apply Settings on Front End
export const SET_SITE_SETTINGS_START = 'SET_SITE_SETTINGS_START';
export const SET_SITE_SETTINGS_SUCCESS = 'SET_SITE_SETTINGS_SUCCESS';
export const SET_SITE_SETTINGS_ERROR = 'SET_SITE_SETTINGS_ERROR';

// List your space - step #1 - Get Location Data
export const GET_LOCATION_DATA_START = 'GET_LOCATION_DATA_START';
export const GET_LOCATION_DATA_SUCCESS = 'GET_LOCATION_DATA_SUCCESS';
export const GET_LOCATION_DATA_ERROR = 'GET_LOCATION_DATA_ERROR';

// List your space - step #1 - Update Location Status
export const UPDATE_LOCATION_STATUS = 'UPDATE_LOCATION_STATUS';

// List your space - step #1 - Get Listing Data
export const GET_LISTING_DATA_START = 'GET_LISTING_DATA_START';
export const GET_LISTING_DATA_SUCCESS = 'GET_LISTING_DATA_SUCCESS';
export const GET_LISTING_DATA_ERROR = 'GET_LISTING_DATA_ERROR';

// List your space - step #2 - Get Listing Data
export const GET_LISTING_DATA_STEP2_START = 'GET_LISTING_DATA_STEP2_START';
export const GET_LISTING_DATA_STEP2_SUCCESS = 'GET_LISTING_DATA_STEP2_SUCCESS';
export const GET_LISTING_DATA_STEP2_ERROR = 'GET_LISTING_DATA_STEP2_ERROR';

// List your space - step #3 - Get Listing Data
export const GET_LISTING_DATA_STEP3_START = 'GET_LISTING_DATA_STEP3_START';
export const GET_LISTING_DATA_STEP3_SUCCESS = 'GET_LISTING_DATA_STEP3_SUCCESS';
export const GET_LISTING_DATA_STEP3_ERROR = 'GET_LISTING_DATA_STEP3_ERROR';

// List your space - step #1 - Update Map Data from Location Form
export const UPDATE_LISTING_MAP_START = 'UPDATE_LISTING_MAP_START';
export const UPDATE_LISTING_MAP_SUCCESS = 'UPDATE_LISTING_MAP_SUCCESS';
export const UPDATE_LISTING_MAP_ERROR = 'UPDATE_LISTING_MAP_ERROR';

// List your space - steps - Get Listing Steps Data
export const GET_LISTING_STEPS_DATA_START = 'GET_LISTING_STEPS_DATA_START';
export const SET_NEW_LISTING_DATA = 'SET_NEW_LISTING_DATA';
export const GET_LISTING_STEPS_DATA_SUCCESS = 'GET_LISTING_STEPS_DATA_SUCCESS';
export const GET_LISTING_STEPS_DATA_ERROR = 'GET_LISTING_STEPS_DATA_ERROR';
export const RESET_LISTING_STEPS_DATA_START = 'RESET_LISTING_STEPS_DATA_START';
export const RESET_LISTING_STEPS_DATA_SUCCESS =
  'RESET_LISTING_STEPS_DATA_SUCCESS';
export const RESET_LISTING_STEPS_DATA_ERROR = 'RESET_LISTING_STEPS_DATA_ERROR';

// List your space - Manage Listing Steps Data
export const MANAGE_LISTING_STEPS_DATA_START =
  'MANAGE_LISTING_STEPS_DATA_START';
export const MANAGE_LISTING_STEPS_DATA_SUCCESS =
  'MANAGE_LISTING_STEPS_DATA_SUCCESS';
export const MANAGE_LISTING_STEPS_DATA_ERROR =
  'MANAGE_LISTING_STEPS_DATA_ERROR';

// Toggle Menu
export const OPEN_TOGGLE_MENU = 'OPEN_TOGGLE_MENU';
export const CLOSE_TOGGLE_MENU = 'CLOSE_TOGGLE_MENU';

// Login Modal Open and Close actions
export const OPEN_LONGIN_MODAL = 'OPEN_LONGIN_MODAL';
export const CLOSE_LONGIN_MODAL = 'CLOSE_LONGIN_MODAL';

// Signup Modal Open and Close actions
export const OPEN_SIGNUP_MODAL = 'OPEN_SIGNUP_MODAL';
export const CLOSE_FORGOT_PASSWORD_MODAL = 'CLOSE_FORGOT_PASSWORD_MODAL';

// Signup Modal Open and Close actions
export const OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL';
export const CLOSE_SIGNUP_MODAL = 'CLOSE_SIGNUP_MODAL';

// List your space - Get Listing Settings
export const GET_LISTING_FIELDS_DATA_START = 'GET_LISTING_FIELDS_DATA_START';
export const GET_LISTING_FIELDS_DATA_SUCCESS =
  'GET_LISTING_FIELDS_DATA_SUCCESS';
export const GET_LISTING_FIELDS_DATA_ERROR = 'GET_LISTING_FIELDS_DATA_ERROR';

// List your Review
export const GET_REVIEW_DATA_START = 'GET_REVIEW_DATA_START';
export const GET_REVIEW_DATA_SUCCESS = 'GET_REVIEW_DATA_SUCCESS';
export const GET_REVIEW_DATA_ERROR = 'GET_REVIEW_DATA_ERROR';

// Get Specific Listing Settings
export const GET_LISTING_SPECIFIC_FIELDS_DATA_START =
  'GET_LISTING_SPECIFIC_FIELDS_DATA_START';
export const GET_LISTING_SPECIFIC_FIELDS_DATA_SUCCESS =
  'GET_LISTING_SPECIFIC_FIELDS_DATA_SUCCESS';
export const GET_LISTING_SPECIFIC_FIELDS_DATA_ERROR =
  'GET_LISTING_SPECIFIC_FIELDS_DATA_ERROR';

// List your space - Get Listing Fields Initial Values
export const GET_LISTING_FIELDS_INTIAL_VALUES_START =
  'GET_LISTING_FIELDS_INTIAL_VALUES_START';
export const GET_LISTING_FIELDS_INTIAL_VALUES_SUCCESS =
  'GET_LISTING_FIELDS_INTIAL_VALUES_SUCCESS';
export const GET_LISTING_FIELDS_INTIAL_VALUES_ERROR =
  'GET_LISTING_FIELDS_INTIAL_VALUES_ERROR';

// List your space - Create List Photos
export const CREATE_LIST_PHOTOS_START = 'CREATE_LIST_PHOTOS_START';
export const CREATE_LIST_PHOTOS_SUCCESS = 'CREATE_LIST_PHOTOS_SUCCESS';
export const CREATE_LIST_PHOTOS_ERROR = 'CREATE_LIST_PHOTOS_ERROR';

// List your space - Show List Photos
export const SHOW_LIST_PHOTOS_START = 'SHOW_LIST_PHOTOS_START';
export const SHOW_LIST_PHOTOS_SUCCESS = 'SHOW_LIST_PHOTOS_SUCCESS';
export const SHOW_LIST_PHOTOS_ERROR = 'SHOW_LIST_PHOTOS_ERROR';

// Hostfully sync
export const HOSTFULLY_SYNC_START = 'HOSTFULLY_SYNC_START';
export const HOSTFULLY_SYNC_SUCCESS = 'HOSTFULLY_SYNC_SUCCESS';
export const HOSTFULLY_SYNC_PROCESS = 'HOSTFULLY_SYNC_PROCESS';
export const HOSTFULLY_SYNC_ERROR = 'HOSTFULLY_SYNC_ERROR';

// List your space - Show List Photos
export const REMOVE_LIST_PHOTOS_START = 'REMOVE_LIST_PHOTOS_START';
export const REMOVE_LIST_PHOTOS_SUCCESS = 'REMOVE_LIST_PHOTOS_SUCCESS';
export const REMOVE_LIST_PHOTOS_ERROR = 'REMOVE_LIST_PHOTOS_ERROR';

// List your space - Show List Photos
export const HIDE_LIST_PHOTO_START = 'HIDE_LIST_PHOTO_START';
export const HIDE_LIST_PHOTO_SUCCESS = 'HIDE_LIST_PHOTO_SUCCESS';
export const HIDE_LIST_PHOTO_ERROR = 'HIDE_LIST_PHOTO_ERROR';

// List your space - Show List Photos
export const CHECK_AVAILABLE_DATES_START = 'CHECK_AVAILABLE_DATES_START';
export const CHECK_AVAILABLE_DATES_SUCCESS = 'CHECK_AVAILABLE_DATES_SUCCESS';
export const CHECK_AVAILABLE_DATES_ERROR = 'CHECK_AVAILABLE_DATES_ERROR';

// save blocked dates
export const SAVE_BLOCKED_DATES = 'SAVE_BLOCKED_DATES';

// Currency Rates Fetch
export const CURRENCY_RATES_FETCH_START = 'CURRENCY_RATES_FETCH_START';
export const CURRENCY_RATES_FETCH_SUCCESS = 'CURRENCY_RATES_FETCH_SUCCESS';
export const CURRENCY_RATES_FETCH_ERROR = 'CURRENCY_RATES_FETCH_ERROR';

// Store Currency Rates
export const STORE_CURRENCY_RATES_START = 'STORE_CURRENCY_RATES_START';
export const STORE_CURRENCY_RATES_SUCCESS = 'STORE_CURRENCY_RATES_SUCCESS';
export const STORE_CURRENCY_RATES_ERROR = 'STORE_CURRENCY_RATES_ERROR';

// Get Currency List from Currencies Table
export const GET_CURRENCIES_START = 'GET_CURRENCIES_START';
export const GET_CURRENCIES_SUCCESS = 'GET_CURRENCIES_SUCCESS';
export const GET_CURRENCIES_ERROR = 'GET_CURRENCIES_ERROR';

// Select Currency from Dropdown
export const CHOSE_TO_CURRENCY_START = 'CHOSE_TO_CURRENCY_START';
export const CHOSE_TO_CURRENCY_SUCCESS = 'CHOSE_TO_CURRENCY_SUCCESS';
export const CHOSE_TO_CURRENCY_ERROR = 'CHOSE_TO_CURRENCY_ERROR';

// Remove Listing
export const REMOVE_LISTING_START = 'REMOVE_LISTING_START';
export const REMOVE_LISTING_SUCCESS = 'REMOVE_LISTING_SUCCESS';
export const REMOVE_LISTING_ERROR = 'REMOVE_LISTING_ERROR';

// Manage Listing Publish Status
export const MANANGE_LISTING_PUBLISH_STATUS_START =
  'MANANGE_LISTING_PUBLISH_STATUS_START';
export const MANANGE_LISTING_PUBLISH_STATUS_SUCCESS =
  'MANANGE_LISTING_PUBLISH_STATUS_SUCCESS';
export const MANANGE_LISTING_PUBLISH_STATUS_ERROR =
  'MANANGE_LISTING_PUBLISH_STATUS_ERROR';

// View Listing - Image Slider Lightbox
export const IMAGE_LIGHTBOX_OPEN = 'IMAGE_LIGHTBOX_OPEN';
export const IMAGE_LIGHTBOX_CLOSE = 'IMAGE_LIGHTBOX_CLOSE';

// Search Results
export const LOADING_SEARCH_RESULTS = 'LOADING_SEARCH_RESULTS';
export const FETCH_SEARCH_RESULTS_START = 'FETCH_SEARCH_RESULTS_START';
export const FETCH_SEARCH_RESULTS_SUCCESS = 'FETCH_SEARCH_RESULTS_SUCCESS';
export const FETCH_SEARCH_RESULTS_ERROR = 'FETCH_SEARCH_RESULTS_ERROR';

// Search Filter Toggle
export const SEARCH_FILTER_TOGGLE_OPEN = 'SEARCH_FILTER_TOGGLE_OPEN';
export const SEARCH_FILTER_TOGGLE_CLOSE = 'SEARCH_FILTER_TOGGLE_CLOSE';

// Get Search Settings
export const GET_SEARCH_SETTINGS_START = 'GET_SEARCH_SETTINGS_START';
export const GET_SEARCH_SETTINGS_SUCCESS = 'GET_SEARCH_SETTINGS_SUCCESS';
export const GET_SEARCH_SETTINGS_ERROR = 'GET_SEARCH_SETTINGS_ERROR';

// Set Personalized Values
export const SET_PERSONALIZED_VALUES = 'SET_PERSONALIZED_VALUES';

// Search from home page
export const SEARCH_LISTING_START = 'SEARCH_LISTING_START';
export const SEARCH_LISTING_SUCCESS = 'SEARCH_LISTING_SUCCESS';
export const SEARCH_LISTING_ERROR = 'SEARCH_LISTING_ERROR';

// Search page on Mobile screen - Show Map
export const SHOW_SEARCH_RESULTS_MAP = 'SHOW_SEARCH_RESULTS_MAP';

// Search page on Mobile screen - Show Results
export const SHOW_SEARCH_RESULTS = 'SHOW_SEARCH_RESULTS';

// Search page on Mobile screen - Show Form
export const SHOW_SEARCH_FORM = 'SHOW_SEARCH_FORM';

// Trust and Verification - Disconnect from Social Media
export const UPDATE_VERIFICATION_START = 'UPDATE_VERIFICATION_START';
export const UPDATE_VERIFICATION_SUCCESS = 'UPDATE_VERIFICATION_SUCCESS';
export const UPDATE_VERIFICATION_ERROR = 'UPDATE_VERIFICATION_ERROR';

// Trust and Verification - Email Verification Confirmation
export const EMAIL_VERIFICATION_START = 'EMAIL_VERIFICATION_START';
export const EMAIL_VERIFICATION_SUCCESS = 'EMAIL_VERIFICATION_SUCCESS';
export const EMAIL_VERIFICATION_ERROR = 'EMAIL_VERIFICATION_ERROR';

// Trust and Verification - Email Verification Confirmation
export const RESEND_EMAIL_VERIFICATION_START =
  'RESEND_EMAIL_VERIFICATION_START';
export const RESEND_EMAIL_VERIFICATION_SUCCESS =
  'RESEND_EMAIL_VERIFICATION_SUCCESS';
export const RESEND_EMAIL_VERIFICATION_ERROR =
  'RESEND_EMAIL_VERIFICATION_ERROR';

// Trust and Verification - Email Content Male User
export const EMAIL_CONTENT_MALE_USER_START = 'EMAIL_CONTENT_MALE_USER_START';
export const EMAIL_CONTENT_MALE_USER_SUCCESS =
  'EMAIL_CONTENT_MALE_USER_SUCCESS';
export const EMAIL_CONTENT_MALE_USER_ERROR = 'EMAIL_CONTENT_MALE_USER_ERROR';

// Trust and Verification - Email Content Female User
export const EMAIL_CONTENT_FEMALE_USER_START =
  'EMAIL_CONTENT_FEMALE_USER_START';
export const EMAIL_CONTENT_FEMALE_USER_SUCCESS =
  'EMAIL_CONTENT_FEMALE_USER_SUCCESS';
export const EMAIL_CONTENT_FEMALE_USER_ERROR =
  'EMAIL_CONTENT_FEMALE_USER_ERROR';

// Send Forgot Password Email
export const SEND_FORGOT_PASSWORD_START = 'SEND_FORGOT_PASSWORD_START';
export const SEND_FORGOT_PASSWORD_SUCCESS = 'SEND_FORGOT_PASSWORD_SUCCESS';
export const SEND_FORGOT_PASSWORD_ERROR = 'SEND_FORGOT_PASSWORD_ERROR';

// Update Forgot Password
export const UPDATE_FORGOT_PASSWORD_START = 'UPDATE_FORGOT_PASSWORD_START';
export const UPDATE_FORGOT_PASSWORD_SUCCESS = 'UPDATE_FORGOT_PASSWORD_SUCCESS';
export const UPDATE_FORGOT_PASSWORD_ERROR = 'UPDATE_FORGOT_PASSWORD_ERROR';

// Upload Profile Picture
export const PROFILE_PICTURE_LOADER_START = 'PROFILE_PICTURE_LOADER_START';
export const UPLOAD_PROFILE_PICTURE_START = 'UPLOAD_PROFILE_PICTURE_START';
export const UPLOAD_PROFILE_PICTURE_SUCCESS = 'UPLOAD_PROFILE_PICTURE_SUCCESS';
export const UPLOAD_PROFILE_PICTURE_ERROR = 'UPLOAD_PROFILE_PICTURE_ERROR';

// Upload Document Picture
export const DOCUMENT_PICTURE_LOADER_START = 'DOCUMENT_PICTURE_LOADER_START';

// Upload Profile Picture
export const REMOVE_PROFILE_PICTURE_START = 'REMOVE_PROFILE_PICTURE_START';
export const REMOVE_PROFILE_PICTURE_SUCCESS = 'REMOVE_PROFILE_PICTURE_SUCCESS';
export const REMOVE_PROFILE_PICTURE_ERROR = 'REMOVE_PROFILE_PICTURE_ERROR';

// List Views
export const RECORD_LIST_VIEWS_START = 'RECORD_LIST_VIEWS_START';
export const RECORD_LIST_VIEWS_SUCCESS = 'RECORD_LIST_VIEWS_SUCCESS';
export const RECORD_LIST_VIEWS_ERROR = 'RECORD_LIST_VIEWS_ERROR';

// Contact Host
export const CONTACT_HOST_START = 'CONTACT_HOST_START';
export const CONTACT_HOST_SUCCESS = 'CONTACT_HOST_SUCCESS';
export const CONTACT_HOST_ERROR = 'CONTACT_HOST_ERROR';

// Send Message
export const SEND_MESSAGE_START = 'SEND_MESSAGE_START';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';

// Contact Host Modal
export const CONTACT_HOST_OPEN = 'CONTACT_HOST_OPEN';
export const CONTACT_HOST_CLOSE = 'CONTACT_HOST_CLOSE';

// Read Messages
export const READ_MESSAGE_START = 'READ_MESSAGE_START';
export const READ_MESSAGE_SUCCESS = 'READ_MESSAGE_SUCCESS';
export const READ_MESSAGE_ERROR = 'READ_MESSAGE_ERROR';

// Booking Process
export const BOOKING_PROCESS_START = 'BOOKING_PROCESS_START';
export const BOOKING_PROCESS_SUCCESS = 'BOOKING_PROCESS_SUCCESS';
export const BOOKING_PROCESS_ERROR = 'BOOKING_PROCESS_ERROR';

// Booking Payment
export const BOOKING_PAYMENT_START = 'BOOKING_PAYMENT_START';
export const BOOKING_PAYMENT_SUCCESS = 'BOOKING_PAYMENT_SUCCESS';
export const BOOKING_PAYMENT_ERROR = 'BOOKING_PAYMENT_ERROR';

// Booking Payment - For Cancel from Paypal
export const BOOKING_PAYMENT_FOR_CANCEL_START =
  'BOOKING_PAYMENT_FOR_CANCEL_START';
export const BOOKING_PAYMENT_FOR_CANCEL_SUCCESS =
  'BOOKING_PAYMENT_FOR_CANCEL_SUCCESS';
export const BOOKING_PAYMENT_FOR_CANCEL_ERROR =
  'BOOKING_PAYMENT_FOR_CANCEL_ERROR';

// Payout - Add
export const ADD_PAYOUT_START = 'Add_PAYOUT_START';
export const ADD_PAYOUT_SUCCESS = 'ADD_PAYOUT_SUCCESS';
export const ADD_PAYOUT_ERROR = 'ADD_PAYOUT_ERROR';

// Payout - Remove
export const REMOVE_PAYOUT_START = 'REMOVE_PAYOUT_START';
export const REMOVE_PAYOUT_SUCCESS = 'REMOVE_PAYOUT_SUCCESS';
export const REMOVE_PAYOUT_ERROR = 'REMOVE_PAYOUT_ERROR';

// Payout - Add
export const SET_DEFAULT_PAYOUT_START = 'SET_DEFAULT_PAYOUT_START';
export const SET_DEFAULT_PAYOUT_SUCCESS = 'SET_DEFAULT_PAYOUT_SUCCESS';
export const SET_DEFAULT_PAYOUT_ERROR = 'SET_DEFAULT_PAYOUT_ERROR';

// Transaction History - Change Payout
export const CHANGE_PAYOUT_START = 'CHANGE_PAYOUT_START';
export const CHANGE_PAYOUT_SUCCESS = 'CHANGE_PAYOUT_SUCCESS';
export const CHANGE_PAYOUT_ERROR = 'CHANGE_PAYOUT_ERROR';

// Get Service Fee
export const GET_SERVICE_FEES_START = 'GET_SERVICE_FEES_START';
export const GET_SERVICE_FEES_SUCCESS = 'GET_SERVICE_FEES_SUCCESS';
export const GET_SERVICE_FEES_ERROR = 'GET_SERVICE_FEES_ERROR';

// Host & Guest Actions on Reservation
export const UPDATE_RESERVATION_STATE_START = 'UPDATE_RESERVATION_STATE_START';
export const UPDATE_RESERVATION_STATE_SUCCESS =
  'UPDATE_RESERVATION_STATE_SUCCESS';
export const UPDATE_RESERVATION_STATE_ERROR = 'UPDATE_RESERVATION_STATE_ERROR';

// Host & Guest Actions on Reservation
export const CANCEL_RESERVATION_START = 'CANCEL_RESERVATION_START';
export const CANCEL_RESERVATION_SUCCESS = 'CANCEL_RESERVATION_SUCCESS';
export const CANCEL_RESERVATION_STATE_ERROR = 'CANCEL_RESERVATION_STATE_ERROR';

// Loader Buttons
export const SET_LOADER_START = 'SET_LOADER_START';
export const SET_LOADER_COMPLETE = 'SET_LOADER_COMPLETE';

// Import Calendar
export const IMPORT_CALENDAR_START = 'IMPORT_CALENDAR_START';
export const IMPORT_CALENDAR_SUCCESS = 'IMPORT_CALENDAR_SUCCESS';
export const IMPORT_CALENDAR_ERROR = 'IMPORT_CALENDAR_ERROR';

// Delete Import Calendar
export const DELETE_IMPORT_CALENDAR_START = 'DELETE_IMPORT_CALENDAR_START';
export const DELETE_IMPORT_CALENDAR_SUCCESS = 'DELETE_IMPORT_CALENDAR_SUCCESS';
export const DELETE_IMPORT_CALENDAR_ERROR = 'DELETE_IMPORT_CALENDAR_ERROR';

/**

 Constants for SiteAdmin

 * */

// View Receipt - Reservation Management
export const ADMIN_VIEW_RECEIPT_START = 'ADMIN_VIEW_RECEIPT_START';
export const ADMIN_VIEW_RECEIPT_SUCCESS = 'ADMIN_VIEW_RECEIPT_SUCCESS';
export const ADMIN_VIEW_RECEIPT_ERROR = 'ADMIN_VIEW_RECEIPT_ERROR';

// Update Service Fees
export const ADMIN_UPDATE_SERVICE_FEES_START =
  'ADMIN_UPDATE_SERVICE_FEES_START';
export const ADMIN_UPDATE_SERVICE_FEES_SUCCESS =
  'ADMIN_UPDATE_SERVICE_FEES_SUCCESS';
export const ADMIN_UPDATE_SERVICE_FEES_ERROR =
  'ADMIN_UPDATE_SERVICE_FEES_ERROR';

// Payout Host - Reservation Management
export const ADMIN_PAYOUT_HOST_START = 'ADMIN_PAYOUT_HOST_START';
export const ADMIN_PAYOUT_HOST_SUCCESS = 'ADMIN_PAYOUT_HOST_SUCCESS';
export const ADMIN_PAYOUT_HOST_ERROR = 'ADMIN_PAYOUT_HOST_ERROR';

// Refund Guest - Reservation Management
export const ADMIN_REFUND_GUEST_START = 'ADMIN_REFUND_GUEST_START';
export const ADMIN_REFUND_GUEST_SUCCESS = 'ADMIN_REFUND_GUEST_SUCCESS';
export const ADMIN_REFUND_GUEST_ERROR = 'ADMIN_REFUND_GUEST_ERROR';

// Delete User from UserManagement
export const ADMIN_DELETE_USER_START = 'ADMIN_DELETE_USER_START';
export const ADMIN_DELETE_USER_SUCCESS = 'ADMIN_DELETE_USER_SUCCESS';
export const ADMIN_DELETE_USER_ERROR = 'ADMIN_DELETE_USER_ERROR';

// Load Listing Settings Data
export const ADMIN_LOAD_LIST_SETTINGS_START = 'ADMIN_LOAD_LIST_SETTINGS_START';
export const ADMIN_LOAD_LIST_SETTINGS_SUCCESS =
  'ADMIN_LOAD_LIST_SETTINGS_SUCCESS';
export const ADMIN_LOAD_LIST_SETTINGS_ERROR = 'ADMIN_LOAD_LIST_SETTINGS_ERROR';

// Load USER Invite List Settings Data
export const ADMIN_LOAD_INVITE_SETTINGS_START =
  'ADMIN_LOAD_INVITE_SETTINGS_START';
export const ADMIN_LOAD_INVITE_SETTINGS_SUCCESS =
  'ADMIN_LOAD_INVITE_SETTINGS_SUCCESS';
export const ADMIN_LOAD_INVITE_SETTINGS_ERROR =
  'ADMIN_LOAD_INVITE_SETTINGS_ERROR';

// Listing Settings Modal Open and Close actions
export const OPEN_LIST_SETTINGS_MODAL = 'OPEN_LIST_SETTINGS_MODAL';
export const CLOSE_LIST_SETTINGS_MODAL = 'CLOSE_LIST_SETTINGS_MODAL';

// Max invite Settings Modal Open and Close actions
export const OPEN_MAXINVITE_SETTINGS_MODAL = 'OPEN_MAXINVITE_SETTINGS_MODAL';
export const CLOSE_MAXINVITE_SETTINGS_MODAL = 'CLOSE_MAXINVITE_SETTINGS_MODAL';

// Delete Listing Settings
export const DELETE_LIST_SETTINGS_START = 'DELETE_LIST_SETTINGS_START';
export const DELETE_LIST_SETTINGS_SUCCESS = 'DELETE_LIST_SETTINGS_SUCCESS';
export const DELETE_LIST_SETTINGS_ERROR = 'DELETE_LIST_SETTINGS_ERROR';

// Enable / Disable Currencies
export const CHANGE_CURRENCY_STATUS_START = 'CHANGE_CURRENCY_STATUS_START';
export const CHANGE_CURRENCY_STATUS_SUCCESS = 'CHANGE_CURRENCY_STATUS_SUCCESS';
export const CHANGE_CURRENCY_STATUS_ERROR = 'CHANGE_CURRENCY_STATUS_ERROR';

// Set Base Currency
export const SET_BASE_CURRENCY_START = 'SET_BASE_CURRENCY_START';
export const SET_BASE_CURRENCY_SUCCESS = 'SET_BASE_CURRENCY_SUCCESS';
export const SET_BASE_CURRENCY_ERROR = 'SET_BASE_CURRENCY_ERROR';

// Upload Logo
export const LOGO_UPLOAD_LOADER_START = 'LOGO_UPLOAD_LOADER_START';
export const LOGO_UPLOAD_START = 'LOGO_UPLOAD_START';
export const LOGO_UPLOAD_SUCCESS = 'LOGO_UPLOAD_SUCCESS';
export const LOGO_UPLOAD_ERROR = 'LOGO_UPLOAD_ERROR';

// Get Logo
export const GET_LOGO_START = 'GET_LOGO_START';
export const GET_LOGO_SUCCESS = 'GET_LOGO_SUCCESS';
export const GET_LOGO_ERROR = 'GET_LOGO_ERROR';

// Remove Logo
export const REMOVE_LOGO_START = 'REMOVE_LOGO_START';
export const REMOVE_LOGO_SUCCESS = 'REMOVE_LOGO_SUCCESS';
export const REMOVE_LOGO_ERROR = 'REMOVE_LOGO_ERROR';

// Recommend List

/** Listing Management * */

// Add Recommend
export const ADD_RECOMMEND_START = 'ADD_RECOMMEND_START';
export const ADD_RECOMMEND_SUCCESS = 'ADD_RECOMMEND_SUCCESS';
export const ADD_RECOMMEND_ERROR = 'ADD_RECOMMEND_ERROR';
export const ADD_RECOMMEND_EXCEED_LIMIT = 'ADD_RECOMMEND_EXCEED_LIMIT';
export const ADD_RECOMMEND_NOT_PUBLISH_MESSAGE =
  'ADD_RECOMMEND_NOT_PUBLISH_MESSAGE';

// Remove Recommend
export const REMOVE_RECOMMEND_START = 'REMOVE_RECOMMEND_START';
export const REMOVE_RECOMMEND_SUCCESS = 'REMOVE_RECOMMEND_SUCCESS';
export const REMOVE_RECOMMEND_ERROR = 'REMOVE_RECOMMEND_ERROR';

// Remove Listing
export const SITE_ADMIN_REMOVE_LISTING_START =
  'SITE_ADMIN_REMOVE_LISTING_START';
export const SITE_ADMIN_REMOVE_LISTING_SUCCESS =
  'SITE_ADMIN_REMOVE_LISTING_SUCCESS';
export const SITE_ADMIN_REMOVE_LISTING_ERROR =
  'SITE_ADMIN_REMOVE_LISTING_ERROR';

/** Listing Management * */

// Upate Banner Form
export const UPDATE_IMAGE_BANNER_START = 'UPDATE_IMAGE_BANNER_START';
export const UPDATE_IMAGE_BANNER_SUCCESS = 'UPDATE_IMAGE_BANNER_SUCCESS';
export const UPDATE_IMAGE_BANNER_ERROR = 'UPDATE_IMAGE_BANNER_ERROR';

// Upate Banner Form
export const IMAGE_BANNER_UPLOAD_LOADER_START =
  'IMAGE_BANNER_UPLOAD_LOADER_START';
export const UPLOAD_IMAGE_BANNER_START = 'UPLOAD_IMAGE_BANNER_START';
export const UPLOAD_IMAGE_BANNER_SUCCESS = 'UPLOAD_IMAGE_BANNER_SUCCESS';
export const UPLOAD_IMAGE_BANNER_ERROR = 'UPLOAD_IMAGE_BANNER_ERROR';

// Upate Banner Form
export const REMOVE_IMAGE_BANNER_START = 'REMOVE_IMAGE_BANNER_START';
export const REMOVE_IMAGE_BANNER_SUCCESS = 'REMOVE_IMAGE_BANNER_SUCCESS';
export const REMOVE_IMAGE_BANNER_ERROR = 'REMOVE_IMAGE_BANNER_ERROR';

// MANAGE PAYMENT CURRENCY - SITE ADMIN
export const ADMIN_MANAGE_PAYMENT_CURRENCY_START =
  'ADMIN_MANAGE_PAYMENT_CURRENCY_START';
export const ADMIN_MANAGE_PAYMENT_CURRENCY_SUCCESS =
  'ADMIN_MANAGE_PAYMENT_CURRENCY_SUCCESS';
export const ADMIN_MANAGE_PAYMENT_CURRENCY_ERROR =
  'ADMIN_MANAGE_PAYMENT_CURRENCY_ERROR';

// Site Admin - Reservation Modal
export const ADMIN_RESERVATION_MODAL_SHOW = 'ADMIN_RESERVATION_MODAL_SHOW';
export const ADMIN_RESERVATION_MODAL_HIDE = 'ADMIN_RESERVATION_MODAL_HIDE';

// Feature Alert
export const FEATURE_ALERT_MODAL_SHOW = 'FEATURE_ALERT_MODAL_SHOW';
export const FEATURE_ALERT_MODAL_HIDE = 'FEATURE_ALERT_MODAL_HIDE';

// Admin Reviews
export const ADMIN_DELETE_REVIEW_START = 'ADMIN_DELETE_REVIEW_START';
export const ADMIN_DELETE_REVIEW_SUCCESS = 'ADMIN_DELETE_REVIEW_SUCCESS';
export const ADMIN_DELETE_REVIEW_ERROR = 'ADMIN_DELETE_REVIEW_ERROR';
// WishList Group ADD & EDIT
export const OPEN_WISH_LIST_GROUP_MODAL = 'OPEN_WISH_LIST_GROUP_MODAL';
export const CLOSE_WISH_LIST_GROUP_MODAL = 'CLOSE_WISH_LIST_GROUP_MODAL';

// Delete Wish List Group
export const DELETE_WISH_LIST_GROUP_START = 'DELETE_WISH_LIST_GROUP_START';
export const DELETE_WISH_LIST_GROUP_SUCCESS = 'DELETE_WISH_LIST_GROUP_SUCCESS';
export const DELETE_WISH_LIST_GROUP_ERROR = 'DELETE_WISH_LIST_GROUP_ERROR';

// WishList Modal
export const OPEN_WISH_LIST_MODAL = 'OPEN_WISH_LIST_MODAL';
export const CLOSE_WISH_LIST_MODAL = 'CLOSE_WISH_LIST_MODAL';

// Sticky Book Section
export const SET_STICKY_TOP = 'SET_STICKY_TOP';
export const SET_STICKY_BOTTOM = 'SET_STICKY_BOTTOM';

// Report user modal
export const OPEN_REPORT_USER_MODAL = 'OPEN_REPORT_USER_MODAL';
export const CLOSE_REPORT_USER_MODAL = 'CLOSE_REPORT_USER_MODAL';

// Report user Thank you modal
export const OPEN_THANK_YOU_MODAL = 'OPEN_THANK_YOU_MODAL';
export const CLOSE_THANK_YOU_MODAL = 'CLOSE_THANK_YOU_MODAL';

// SMS Verification Modal
export const OPEN_SMS_VERIFICATION_MODAL = 'OPEN_SMS_VERIFICATION_MODAL';
export const CLOSE_SMS_VERIFICATION_MODAL = 'CLOSE_SMS_VERIFICATION_MODAL';

// SEND VERIFICATION SMS
export const SEND_VERIFICATION_SMS_START = 'SEND_VERIFICATION_SMS_START';
export const SEND_VERIFICATION_SMS_SUCCESS = 'SEND_VERIFICATION_SMS_SUCCESS';
export const SEND_VERIFICATION_SMS_ERROR = 'SEND_VERIFICATION_SMS_ERROR';

// GENDER VERIFICATION
export const GENDER_STORE_START = 'GENDER_STORE_START';
export const GENDER_STORE_SUCCESS = 'GENDER_STORE_SUCCESS';
export const GENDER_STORE_ERROR = 'GENDER_STORE_ERROR';

// Invite Details
export const INVITE_DETAILS_START = 'INVITE_DETAILS_START';
export const INVITE_DETAILS_SUCCESS = 'INVITE_DETAILS_SUCCESS';
export const INVITE_DETAILS_ERROR = 'INVITE_DETAILS_ERROR';

// Referral code modal
export const OPEN_REFERRAL_INSERT_MODAL = 'OPEN_REFERRAL_INSERT_MODAL';
export const CLOSE_REFERRAL_INSERT_MODAL = 'CLOSE_REFERRAL_INSERT_MODAL';

// Once User visit homepage first time modal
export const OPEN_NEW_USER_INSERT_MODAL = 'OPEN_NEW_USER_INSERT_MODAL';
export const CLOSE_NEW_USER_INSERT_MODAL = 'CLOSE_NEW_USER_INSERT_MODAL';

// Referral value store
export const REFERRAL_KEY_DATA_START = 'REFERRAL_KEY_DATA_START';
export const REFERRAL_KEY_DATA_SUCCESS = 'REFERRAL_KEY_DATA_SUCCESS';
export const REFERRAL_KEY_DATA_ERROR = 'REFERRAL_KEY_DATA_ERROR';

// Mutual connection - connecting user store
export const UPDATE_CONNECT_USER_START = 'UPDATE_CONNECT_USER_START';
export const UPDATE_CONNECT_USER_SUCCESS = 'UPDATE_CONNECT_USER_SUCCESS';
export const UPDATE_CONNECT_USER_ERROR = 'UPDATE_CONNECT_USER_ERROR';

// connection - connecting user store
export const UPDATE_CONNECT_PROFILE_START = 'UPDATE_CONNECT_PROFILE_START';
export const UPDATE_CONNECT_PROFILE_SUCCESS = 'UPDATE_CONNECT_PROFILE_SUCCESS';
export const UPDATE_CONNECT_PROFILE_ERROR = 'UPDATE_CONNECT_PROFILE_ERROR';

export const GET_MUTUAL_CONNECTION_API_START =
  'GET_MUTUAL_CONNECTION_API_START';
export const GET_MUTUAL_CONNECTION_API_SUCCESS =
  'GET_MUTUAL_CONNECTION_API_SUCCESS';
export const GET_MUTUAL_CONNECTION_API_ERROR =
  'GET_MUTUAL_CONNECTION_API_ERROR';

// Get industry search list data
export const GET_INDUSTRY_DATA_START = 'GET_INDUSTRY_DATA_START';
export const GET_INDUSTRY_DATA_SUCCESS = 'GET_INDUSTRY_DATA_SUCCESS';
export const GET_INDUSTRY_DATA_ERROR = 'GET_INDUSTRY_DATA_ERROR';

// Get university search list data
export const GET_UNIVERSITY_DATA_START = 'GET_UNIVERSITY_DATA_START';
export const GET_UNIVERSITY_DATA_SUCCESS = 'GET_UNIVERSITY_DATA_SUCCESS';
export const GET_UNIVERSITY_DATA_ERROR = 'GET_UNIVERSITY_DATA_ERROR';

// Booking Modal for view listing page.
export const OPEN_BOOKING_MODAL = 'OPEN_BOOKING_MODAL';
export const CLOSE_BOOKING_MODAL = 'CLOSE_BOOKING_MODAL';

// Icon insert/update to Listing Amenities from admin panel
export const ICON_SETTING_UPLOAD_LOADER_START =
  'ICON_SETTING_UPLOAD_LOADER_START';
export const ICON_SETTING_UPLOAD_START = 'ICON_SETTING_UPLOAD_START';
export const ICON_SETTING_UPLOAD_SUCCESS = 'ICON_SETTING_UPLOAD_SUCCESS';
export const ICON_SETTING_UPLOAD_ERROR = 'ICON_SETTING_UPLOAD_ERROR';

// Icon insert/update to Listing Amenities from admin panel
export const PRIVATE_MESSAGE_START = 'PRIVATE_MESSAGE_START';
export const PRIVATE_MESSAGE_SUCCESS = 'PRIVATE_MESSAGE_SUCCESS';
export const PRIVATE_MESSAGE_ERROR = 'PRIVATE_MESSAGE_ERROR';

// Message Chat Modal
export const OPEN_MESSAGE_MESSAGE_MODAL = 'OPEN_MESSAGE_MESSAGE_MODAL';
export const CLOSE_MESSAGE_MESSAGE_MODAL = 'CLOSE_MESSAGE_MESSAGE_MODAL';

// Priavte message
export const PRIVATE_MESSAGE_DATA_START = 'PRIVATE_MESSAGE_DATA_START';
export const PRIVATE_MESSAGE_DATA_SUCCESS = 'PRIVATE_MESSAGE_DATA';
export const PRIVATE_MESSAGE_DATA_ERROR = 'PRIVATE_MESSAGE_DATA_ERROR';

// Quote actions
export const QUOTE_MODAL_SHOW = 'QUOTE_MODAL_SHOW';
export const QUOTE_MODAL_HIDE = 'QUOTE_MODAL_HIDE';

// Payout
export const GET_PAYOUT_DETAILS_START = 'GET_PAYOUT_DETAILS_START';
export const GET_PAYOUT_DETAILS_SUCCESS = 'GET_PAYOUT_DETAILS_SUCCESS';
export const GET_PAYOUT_DETAILS_ERROR = 'GET_PAYOUT_DETAILS_ERROR';

// Add Request To Book
export const ADD_PAYMENT_START = 'ADD_PAYMENT_START';
export const ADD_PAYMENT_SUCCESS = 'ADD_PAYMENT_SUCCESS';
export const ADD_PAYMENT_ERROR = 'ADD_PAYMENT_ERROR';

// Profile picture admin upload
export const PICTURE_SETTING_UPLOAD_LOADER_START =
  'PICTURE_SETTING_UPLOAD_LOADER_START';
export const PICTURE_SETTING_UPLOAD_START = 'PICTURE_SETTING_UPLOAD_START';
export const PICTURE_SETTING_UPLOAD_SUCCESS = 'PICTURE_SETTING_UPLOAD_SUCCESS';
export const PICTURE_SETTING_UPLOAD_ERROR = 'PICTURE_SETTING_UPLOAD_ERROR';
export const REMOVE_PICTURE_SETTING_UPLOAD_SUCCESS =
  'REMOVE_PICTURE_SETTING_UPLOAD_SUCCESS';

// Check Male User for Room type
export const CHECK_MALE_LIST_SETTINGS_START = 'CHECK_MALE_LIST_SETTINGS_START';
export const CHECK_MALE_LIST_SETTINGS_SUCCESS =
  'CHECK_MALE_LIST_SETTINGS_SUCCESS';
export const CHECK_MALE_LIST_SETTINGS_ERROR = 'CHECK_MALE_LIST_SETTINGS_ERROR';

// Upload BlogImage
export const BLOGIMAGE_UPLOAD_LOADER_START = 'BLOGIMAGE_UPLOAD_LOADER_START';
export const BLOGIMAGE_UPLOAD_START = 'BLOGIMAGE_UPLOAD_START';
export const BLOGIMAGE_UPLOAD_SUCCESS = 'BLOGIMAGE_UPLOAD_SUCCESS';
export const BLOGIMAGE_UPLOAD_ERROR = 'BLOGIMAGE_UPLOAD_ERROR';

// Remove BlogImage
export const REMOVE_BLOGIMAGE_START = 'REMOVE_BLOGIMAGE_START';
export const REMOVE_BLOGIMAGE_SUCCESS = 'REMOVE_BLOGIMAGE_SUCCESS';
export const REMOVE_BLOGIMAGE_ERROR = 'REMOVE_BLOGIMAGE_ERROR';

// Update Static Page Details
export const ADMIN_UPDATE_STATIC_START = 'ADMIN_UPDATE_STATIC_START';
export const ADMIN_UPDATE_STATIC_SUCCESS = 'ADMIN_UPDATE_STATIC_SUCCESS';
export const ADMIN_UPDATE_STATIC_ERROR = 'ADMIN_UPDATE_STATIC_ERROR';

// Upload Static Location Image
export const STATIC_LOCATION_IMAGE_UPLOAD_LOADER_START =
  'STATIC_LOCATION_IMAGE_UPLOAD_LOADER_START';
export const STATIC_LOCATION_IMAGE_UPLOAD_START =
  'STATIC_LOCATION_IMAGE_UPLOAD_START';
export const STATIC_LOCATION_IMAGE_UPLOAD_SUCCESS =
  'STATIC_LOCATION_IMAGE_UPLOAD_SUCCESS';
export const STATIC_LOCATION_IMAGE_UPLOAD_ERROR =
  'STATIC_LOCATION_IMAGE_UPLOAD_ERROR';

// Remove Static Location Image
export const REMOVE_STATIC_LOCATION_IMAGE_START =
  'REMOVE_STATIC_LOCATION_IMAGE_START';
export const REMOVE_STATIC_LOCATION_IMAGE_SUCCESS =
  'REMOVE_STATIC_LOCATION_IMAGE_SUCCESS';
export const REMOVE_STATIC_LOCATION_IMAGE_ERROR =
  'REMOVE_STATIC_LOCATION_IMAGE_ERROR';

// GET Listing Step Two
export const GET_LISTING_DETAILS_START = 'GET_LISTING_DETAILS_START';
export const GET_LISTING_DETAILS_SUCCESS = 'GET_LISTING_DETAILS_SUCCESS';
export const GET_LISTING_DETAILS_ERROR = 'GET_LISTING_DETAILS_ERROR';

// Get blocked dates
export const GET_BLOCKED_START = 'GET_BLOCKED_START';
export const GET_BLOCKED_SUCCESS = 'GET_BLOCKED_SUCCESS';
export const GET_BLOCKED_ERROR = 'GET_BLOCKED_ERROR';

// GET Listing Special Pricing
export const GET_LISTING_SPECIAL_PRICING_START =
  'GET_LISTING_SPECIAL_PRICING_START';
export const GET_LISTING_SPECIAL_PRICING_SUCCESS =
  'GET_LISTING_SPECIAL_PRICING_SUCCESS';
export const GET_LISTING_SPECIAL_PRICING_ERROR =
  'GET_LISTING_SPECIAL_PRICING_ERROR';

// SET ADMIN CHOSEN USER ID
export const SET_ADMIN_CHOSEN_USER_ID_START = 'SET_ADMIN_CHOSEN_USER_ID_START';
export const SET_ADMIN_CHOSEN_USER_ID_SUCCESS =
  'SET_ADMIN_CHOSEN_USER_ID_SUCCESS';
export const SET_ADMIN_CHOSEN_USER_ID_ERROR = 'SET_ADMIN_CHOSEN_USER_ID_ERROR';

// SET_MEMBER_FORM_STATE
export const SET_MEMBER_FORM_STATE = 'SET_MEMBER_FORM_STATE';

// get lidting blocked and available dates
export const GET_LISTING_BLOCKED_AVAILABLE_DATES_START =
  'GET_LISTING_BLOCKED_AVAILABLE_DATES_START';
export const GET_LISTING_BLOCKED_AVAILABLE_DATES_ERROR =
  'GET_LISTING_BLOCKED_AVAILABLE_DATES_ERROR';
export const GET_LISTING_BLOCKED_AVAILABLE_DATES_SUCCESS =
  'GET_LISTING_BLOCKED_AVAILABLE_DATES_SUCCESS';

// Update Bond Refund Status
export const CHANGE_BOND_REFUND_STATUS_START =
  'CHANGE_BOND_REFUND_STATUS_START';
export const CHANGE_BOND_REFUND_STATUS_SUCCESS =
  'CHANGE_BOND_REFUND_STATUS_SUCCESS';
export const CHANGE_BOND_REFUND_STATUS_ERROR =
  'CHANGE_BOND_REFUND_STATUS_ERROR';

// Upate home Banner
export const UPLOAD_HOME_BANNER_START = 'UPLOAD_HOME_BANNER_START';
export const UPLOAD_HOME_BANNER_SUCCESS = 'UPLOAD_HOME_BANNER_SUCCESS';
export const UPLOAD_HOME_BANNER_ERROR = 'UPLOAD_HOME_BANNER_ERROR';

// Upate Banner Form
export const GET_HOME_BANNER_START = 'GET_HOME_BANNER_START';
export const GET_HOME_BANNER_SUCCESS = 'GET_HOME_BANNER_SUCCESS';
export const GET_HOME_BANNER_ERROR = 'GET_HOME_BANNER_ERROR';

// delete home Banner
export const DELETE_HOME_BANNER_START = 'DELETE_HOME_BANNER_START';
export const DELETE_HOME_BANNER_SUCCESS = 'DELETE_HOME_BANNER_SUCCESS';
export const DELETE_HOME_BANNER_ERROR = 'DELETE_HOME_BANNER_ERROR';
export const IMAGE_BANNER_UPLOAD_LOADER_END = 'IMAGE_BANNER_UPLOAD_LOADER_END';

// Get blocked dates
export const GET_BLOCKED_DATE_START = 'GET_BLOCKED_DATE_START';
export const GET_BLOCKED_DATE_SUCCESS = 'GET_BLOCKED_DATE_SUCCESS';
export const GET_BLOCKED_DATE_ERROR = 'GET_BLOCKED_DATE_ERROR';

// Get modal open
export const OPEN_PERSONAL_MODAL = 'OPEN_PERSONAL_MODAL';
export const CLOSE_PERSONAL_MODAL = 'CLOSE_PERSONAL_MODAL';

// Get phone number entry open
export const OPEN_INPUT_PHONE_MODAL = 'OPEN_INPUT_PHONE_MODAL';
export const CLOSE_INPUT_PHONE_MODAL = 'CLOSE_INPUT_PHONE_MODAL';

// Get hostfully agency id
export const OPEN_HOSTFULLY_AGENCY_MODAL = 'OPEN_HOSTFULLY_AGENCY_MODAL';
export const CLOSE_HOSTFULLY_AGENCY_MODAL = 'CLOSE_HOSTFULLY_AGENCY_MODAL';

// List your space - Create pdf file
export const CREATE_PDF_FILE_START = 'CREATE_PDF_FILE_START';
export const CREATE_PDF_FILE_SUCCESS = 'CREATE_PDF_FILE_SUCCESS';
export const CREATE_PDF_FILE_ERROR = 'CREATE_PDF_FILE_ERROR';

// List your space - Show pdf file
export const SHOW_PDF_FILE_START = 'SHOW_PDF_FILE_START';
export const SHOW_PDF_FILE_SUCCESS = 'SHOW_PDF_FILE_SUCCESS';
export const SHOW_PDF_FILE_ERROR = 'SHOW_PDF_FILE_ERROR';

// List your space - Remove pdf file
export const REMOVE_PDF_FILE_START = 'REMOVE_PDF_FILE_START';
export const REMOVE_PDF_FILE_SUCCESS = 'REMOVE_PDF_FILE_SUCCESS';
export const REMOVE_PDF_FILE_ERROR = 'REMOVE_PDF_FILE_ERROR';

// Get modal open
export const OPEN_EMAIL_MODAL = 'OPEN_EMAIL_MODAL';
export const CLOSE_EMAIL_MODAL = 'CLOSE_EMAIL_MODAL';
// Member Details
export const GET_MEMBER_DETAILS_START = 'GET_MEMBER_DETAILS_START';
export const GET_MEMBER_DETAILS_SUCCESS = 'GET_MEMBER_DETAILS_SUCCESS';
export const GET_MEMBER_DETAILS_ERROR = 'GET_MEMBER_DETAILS_ERROR';

// Get StripeState List
export const GET_STRIPESTATE_START = 'GET_STRIPESTATE_START';
export const GET_STRIPESTATE_SUCCESS = 'GET_STRIPESTATE_SUCCESS';
export const GET_STRIPESTATE_ERROR = 'GET_STRIPESTATE_ERROR';

// Social Share modal
export const OPEN_SOCIAL_SHARE_MODAL = 'OPEN_SOCIAL_SHARE_MODAL';
export const CLOSE_SOCIAL_SHARE_MODAL = 'CLOSE_SOCIAL_SHARE_MODAL';
// Get Press User
export const PRESS_DATA_START = 'PRESS_DATA_START';
export const PRESS_DATA_SUCCESS = 'PRESS_DATA_SUCCESS';
export const PRESS_DATA_ERROR = 'PRESS_DATA_ERROR';

// Get modal open
export const OPEN_SERVICE_MODAL = 'OPEN_SERVICE_MODAL';
export const CLOSE_SERVICE_MODAL = 'CLOSE_SERVICE_MODAL';
// Get property service fee
export const GET_PROPERTY_SERVICE_FEES_START =
  'GET_PROPERTY_SERVICE_FEES_START';
export const GET_PROPERTY_SERVICE_FEES_SUCCESS =
  'GET_PROPERTY_SERVICE_FEES_SUCCESS';
export const GET_PROPERTY_SERVICE_FEES_ERROR =
  'GET_PROPERTY_SERVICE_FEES_ERROR';

// Listing History - OnChange Listing
export const ON_CHANGE_LISTING_START = 'ON_CHANGE_LISTING_START';

// Payout History - Onchange
export const ON_CHANGE_PAYOUT_START = 'ON_CHANGE_PAYOUT_START';

// Get modal open
export const OPEN_PRESS_USER_MODAL = 'OPEN_PRESS_USER_MODAL';
export const CLOSE_PRESS_USER_MODAL = 'CLOSE_PRESS_USER_MODAL';

// More Filters Modal
export const OPEN_MORE_FILTERS_MODAL = 'OPEN_MORE_FILTERS_MODAL';
export const CLOSE_MORE_FILTERS_MODAL = 'CLOSE_MORE_FILTERS_MODAL';

// Photo Description Modal
export const PHOTO_MODAL_SHOW = 'PHOTO_MODAL_SHOW';
export const PHOTO_MODAL_HIDE = 'PHOTO_MODAL_HIDE';

// Connection message Modal
export const OPEN_CONNECTION_MODAL = 'OPEN_CONNECTION_MODAL';
export const CLOSE_CONNECTION_MODAL = 'CLOSE_CONNECTION_MODAL';

// Connection Note message modal
export const OPEN_CONNECTION_NOTE_MODAL = 'OPEN_CONNECTION_NOTE_MODAL';
export const CLOSE_CONNECTION_NOTE_MODAL = 'CLOSE_CONNECTION_NOTE_MODAL';

// Get Admin User
export const GET_ADMIN_USER_START = 'GET_ADMIN_USER_START';
export const GET_ADMIN_USER_SUCCESS = 'GET_ADMIN_USER_SUCCESS';
export const GET_ADMIN_USER_ERROR = 'GET_ADMIN_USER_ERROR';

// Payout - VERIFY
export const VERIFY_PAYOUT_START = 'VERIFY_PAYOUT_START';
export const VERIFY_PAYOUT_SUCCESS = 'VERIFY_PAYOUT_SUCCESS';
export const VERIFY_PAYOUT_ERROR = 'VERIFY_PAYOUT_ERROR';

// Payout - GET
export const GET_PAYOUT_START = 'GET_PAYOUT_START';
export const GET_PAYOUT_SUCCESS = 'GET_PAYOUT_SUCCESS';
export const GET_PAYOUT_ERROR = 'GET_PAYOUT_ERROR';

// Admin Icon Upload
export const ICON_SETTING_NEGATIVE_UPLOAD_START =
  'ICON_SETTING_NEGATIVE_UPLOAD_START';
export const ICON_SETTING_NEGATIVE_UPLOAD_SUCCESS =
  'ICON_SETTING_NEGATIVE_UPLOAD_SUCCESS';
export const ICON_SETTING_NEGATIVE_UPLOAD_ERROR =
  'ICON_SETTING_NEGATIVE_UPLOAD_ERROR';

// Verify Modal
export const VERIFICATION_MODAL_START = 'VERIFICATION_MODAL_START';
export const VERIFICATION_MODAL_SUCCESS = 'VERIFICATION_MODAL_SUCCESS';

// Get Connection Count
export const GET_CONNECTION_COUNT_START = 'GET_CONNECTION_COUNT_START';
export const GET_CONNECTION_COUNT_SUCCESS = 'GET_CONNECTION_COUNT_SUCCESS';
export const GET_CONNECTION_COUNT_ERROR = 'ICON_SETTING_NEGATIVE_UPLOAD_ERROR';

// IDM Verification Modal
export const IDM_VERIFICATION_MODAL_START = 'IDM_VERIFICATION_MODAL_START';
export const IDM_VERIFICATION_MODAL_SUCCESS = 'IDM_VERIFICATION_MODAL_SUCCESS';

// Make a special
export const MAKE_SPECIAL_PRICE_OPEN = 'MAKE_SPECIAL_PRICE_OPEN';
export const MAKE_SPECIAL_PRICE_CLOSE = 'MAKE_SPECIAL_PRICE_CLOSE';

// INDUSTRY
export const INDUSTRY_START = 'INDUSTRY_START';
export const INDUSTRY_SUCCESS = 'INDUSTRY_SUCCESS';
export const INDUSTRY_ERROR = 'INDUSTRY_ERROR';

// Connection Search Form
export const SHOW_CONNECTION_SEARCH_FORM = 'SHOW_CONNECTION_SEARCH_FORM';
export const SHOW_CONNECTION_SEARCH_RESULTS = 'SHOW_CONNECTION_SEARCH_RESULTS';
export const CONNECTION_SEARCH_START = 'CONNECTION_SEARCH_START';
export const CONNECTION_SEARCH_SUCCESS = 'CONNECTION_SEARCH_SUCCESS';
export const CONNECTION_SEARCH_ERROR = 'CONNECTION_SEARCH_ERROR';

// Search from home page
export const SEARCH_MAP_LISTING_START = 'SEARCH_MAP_LISTING_START';
export const SEARCH_MAP_LISTING_SUCCESS = 'SEARCH_MAP_LISTING_SUCCESS';
export const SEARCH_MAP_LISTING_ERROR = 'SEARCH_MAP_LISTING_ERROR';

// Search from home page
export const MAP_DATA_START = 'MAP_DATA_START';
export const MAP_DATA_SUCCESS = 'MAP_DATA_SUCCESS';
export const MAP_DATA_ERROR = 'MAP_DATA_ERROR';

// Get Listing
export const GET_LISTING_SUCCESS = 'GET_LISTING_SUCCESS';

// Get Listing
export const CONFIRM_DUBLICATE_LISTING_START =
  'CONFIRM_DUBLICATE_LISTING_START';
export const CONFIRM_DUBLICATE_LISTING_CLOSE =
  'CONFIRM_DUBLICATE_LISTING_CLOSE';

export const PHOTOS_CONFIRM_DUBLICATE_LISTING_START =
  'PHOTOS_CONFIRM_DUBLICATE_LISTING_START';
export const PHOTOS_CONFIRM_DUBLICATE_LISTING_CLOSE =
  'PHOTOS_CONFIRM_DUBLICATE_LISTING_CLOSE';
// Host Decline Modal
export const HOST_DECLINE_MODAL_START = 'HOST_DECLINE_MODAL_START';
export const HOST_DECLINE_MODAL_SUCCESS = 'HOST_DECLINE_MODAL_SUCCESS';

// Host Decline Modal
export const HOST_MODAL_START = 'HOST_MODAL_START';
export const HOST_MODAL_SUCCESS = 'HOST_MODAL_SUCCESS';

export const EXPLORE_SEARCH_LISTING_SUCCESS = 'EXPLORE_SEARCH_LISTING_SUCCESS';
export const EXPLORE_SEARCH_LISTING_RESULTS = 'EXPLORE_SEARCH_LISTING_RESULTS';

export const RESET_LISTING_DATA_SUCCESS = 'RESET_LISTING_DATA_SUCCESS';

export const PREPARING_DUPLICATE_LISTING_START =
  'PREPARING_DUPLICATE_LISTING_START';
export const PREPARING_DUPLICATE_LISTING_SUCCESS =
  'PREPARING_DUPLICATE_LISTING_SUCCESS';
export const PREPARING_DUPLICATE_LISTING_ERROR =
  'PREPARING_DUPLICATE_LISTING_ERROR';

export const PREPARING_DUPLICATE_NOT_PHOTOS_LISTING_START =
  'PREPARING_DUPLICATE_NOT_PHOTOS_LISTING_START';
export const PREPARING_DUPLICATE_NOT_PHOTOS_LISTING_SUCCESS =
  'PREPARING_DUPLICATE_NOT_PHOTOS_LISTING_SUCCESS';
export const PREPARING_DUPLICATE_NOT_PHOTOS_LISTING_ERROR =
  'PREPARING_DUPLICATE_NOT_PHOTOS_LISTING_ERROR';

// GET Listing Blocked Dates
export const GET_LISTING_BLOCKED_DATES_START =
  'GET_LISTING_BLOCKED_DATES_START';
export const GET_LISTING_BLOCKED_DATES_SUCCESS =
  'GET_LISTING_BLOCKED_DATES_SUCCESS';
export const GET_LISTING_BLOCKED_DATES_ERROR =
  'GET_LISTING_BLOCKED_DATES_ERROR';

// Currency Rates Fetch
export const BLOG_FETCH_START = 'BLOG_FETCH_START';
export const BLOG_FETCH_SUCCESS = 'BLOG_FETCH_SUCCESS';
export const BLOG_FETCH_ERROR = 'BLOG_FETCH_ERROR';

// GET Listing Blocked Dates
export const GET_FULL_LISTING_BLOCKED_DATES_START =
  'GET_FULL_LISTING_BLOCKED_DATES_START';
export const GET_FULL_LISTING_BLOCKED_DATES_SUCCESS =
  'GET_FULL_LISTING_BLOCKED_DATES_SUCCESS';
export const GET_FULL_LISTING_BLOCKED_DATES_ERROR =
  'GET_FULL_LISTING_BLOCKED_DATES_ERROR';

// Property Status
export const PROPERTY_STATUS_MODAL_START = 'PROPERTY_STATUS_MODAL_START';
export const PROPERTY_STATUS_MODAL_SUCCESS = 'PROPERTY_STATUS_MODAL_SUCCESS';

// Manage Listing Publish Status
export const SYNC_MANAGE_LISTING_PUBLISH_STATUS_START =
  'SYNC_MANAGE_LISTING_PUBLISH_STATUS_START';
export const SYNC_MANAGE_LISTING_PUBLISH_STATUS_SUCCESS =
  'SYNC_MANAGE_LISTING_PUBLISH_STATUS_SUCCESS';
export const SYNC_MANAGE_LISTING_PUBLISH_STATUS_ERROR =
  'SYNC_MANAGE_LISTING_PUBLISH_STATUS_ERROR';

// GET RentalUnited Dates
export const RENTALS_UNITED_DATES_START = 'RENTALS_UNITED_DATES_START';
export const RENTALS_UNITED_DATES_SUCCESS = 'RENTALS_UNITED_DATES_SUCCESS';
export const RENTALS_UNITED_DATES_ERROR = 'RENTALS_UNITED_DATES_ERROR';

// Logo Uploader
export const MEMBER_LOGO_UPLOAD_START = 'MEMBER_LOGO_UPLOAD_START';
export const MEMBER_LOGO_UPLOAD_STOP = 'MEMBER_LOGO_UPLOAD_STOP';

// Logo Uploader
export const MEMBER_BANNER_UPLOAD_START = 'MEMBER_BANNER_UPLOAD_START';
export const MEMBER_BANNER_UPLOAD_STOP = 'MEMBER_BANNER_UPLOAD_STOP';

// Logo Uploader
export const UPLOAD_LOGO_START = 'UPLOAD_LOGO_START';
export const UPLOAD_LOGO_SUCCESS = 'UPLOAD_LOGO_SUCCESS';
export const UPLOAD_LOGO_ERROR = 'UPLOAD_LOGO_ERROR';

// Banner Uploader
export const BANNER_LOGO_UPLOAD_START = 'BANNER_LOGO_UPLOAD_START';
export const BANNER_LOGO_UPLOAD_SUCCESS = 'BANNER_LOGO_UPLOAD_SUCCESS';
export const BANNER_LOGO_UPLOAD_STOP = 'BANNER_LOGO_UPLOAD_STOP';

// Members Enable
export const SET_MEMBER_PERKS_START = 'SET_MEMBER_PERKS_START';
export const SET_MEMBER_PERKS_SUCCESS = 'SET_MEMBER_PERKS_SUCCESS';
export const SET_MEMBER_PERKS_ERROR = 'SET_MEMBER_PERKS_ERROR';

// Upload BlogContentImage
export const BLOGCONTENTIMAGE_UPLOAD_LOADER_START =
  'BLOGCONTENTIMAGE_UPLOAD_LOADER_START';
export const BLOGCONTENTIMAGE_UPLOAD_START = 'BLOGCONTENTIMAGE_UPLOAD_START';
export const BLOGCONTENTIMAGE_UPLOAD_SUCCESS =
  'BLOGCONTENTIMAGE_UPLOAD_SUCCESS';
export const BLOGCONTENTIMAGE_UPLOAD_ERROR = 'BLOGCONTENTIMAGE_UPLOAD_ERROR';

// Add blog comment
export const ADD_COMMENT_START = 'ADD_COMMENT_START';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_ERROR = 'ADD_COMMENT_ERROR';

// Members Enable
export const SET_FAQ_START = 'SET_FAQ_START';
export const SET_FAQ_SUCCESS = 'SET_FAQ_SUCCESS';
export const SET_FAQ_ERROR = 'SET_FAQ_ERROR';

// FAQ
// Logo Uploader
export const HOST_LOGO_UPLOAD_START = 'HOST_LOGO_UPLOAD_START';
export const HOST_LOGO_UPLOAD_STOP = 'HOST_LOGO_UPLOAD_STOP';

// Logo Uploader
export const HOST_BANNER_UPLOAD_START = 'HOST_BANNER_UPLOAD_START';
export const HOST_BANNER_UPLOAD_STOP = 'HOST_BANNER_UPLOAD_STOP';

// Social Post modal
export const OPEN_POST_MODAL = 'OPEN_POST_MODAL';
export const CLOSE_POST_MODAL = 'CLOSE_POST_MODAL';

export const OPEN_EDIT_POST_MODAL = 'OPEN_EDIT_POST_MODAL';
export const CLOSE_EDIT_POST_MODAL = 'CLOSE_EDIT_POST_MODAL';

export const OPEN_USER_EDIT_POST_MODAL = 'OPEN_USER_EDIT_POST_MODAL';
export const CLOSE_USER_EDIT_POST_MODAL = 'CLOSE_USER_EDIT_POST_MODAL';

// Delete User from UserManagement
export const USER_ACCESS_START = 'USER_ACCESS_START';
export const USER_ACCESS_SUCCESS = 'USER_ACCESS_SUCCESS';
export const USER_ACCESS_ERROR = 'USER_ACCESS_ERROR';

// Update private status in Admin side
export const UPDATE_BLOG_CONTENT_PRIVATE_STATUS_START =
  'UPDATE_BLOG_CONTENT_PRIVATE_STATUS_START';
export const UPDATE_BLOG_CONTENT_PRIVATE_STATUS_SUCCESS =
  'UPDATE_BLOG_CONTENT_PRIVATE_STATUS_SUCCESS';
export const UPDATE_BLOG_CONTENT_PRIVATE_STATUS_ERROR =
  'UPDATE_BLOG_CONTENT_PRIVATE_STATUS_ERROR';

// Get Hostfully
export const ADMIN_BED_TYPE_HOST_FULLY_START =
  'ADMIN_BED_TYPE_HOST_FULLY_START';
export const ADMIN_BED_TYPE_HOST_FULLY_SUCCESS =
  'ADMIN_BED_TYPE_HOST_FULLY_SUCCESS';

// Get Rentals United
export const ADMIN_BED_TYPE_RENTALS_UNITED_START =
  'ADMIN_BED_TYPE_RENTALS_UNITED_START';
export const ADMIN_BED_TYPE_RENTALS_UNITED_SUCCESS =
  'ADMIN_BED_TYPE_RENTALS_UNITED_SUCCESS';

export const GET_RENTALS_UNITED_BOOKINGS = 'GET_RENTALS_UNITED_BOOKINGS';
export const GET_RENTALS_UNITED_BOOKINGS_START =
  'GET_RENTALS_UNITED_BOOKINGS_START';
export const GET_RENTALS_UNITED_BOOKINGS_SUCCESS =
  'GET_RENTALS_UNITED_BOOKINGS_SUCCESS';

// Load Listing Settings Data
export const ADMIN_EDIT_SETTINGS_START = 'ADMIN_EDIT_SETTINGS_START';
export const ADMIN_EDIT_SETTINGS_SUCCESS = 'ADMIN_EDIT_SETTINGS_SUCCESS';
export const ADMIN_EDIT_SETTINGS_ERROR = 'ADMIN_EDIT_SETTINGS_ERROR';

// Update blog post status in Admin side
export const UPDATE_BLOG_CONTENT_POST_STATUS_START =
  'UPDATE_BLOG_CONTENT_POST_STATUS_START';
export const UPDATE_BLOG_CONTENT_POST_STATUS_SUCCESS =
  'UPDATE_BLOG_CONTENT_POST_STATUS_SUCCESS';
export const UPDATE_BLOG_CONTENT_POST_STATUS_ERROR =
  'UPDATE_BLOG_CONTENT_POST_STATUS_ERROR';

// Restriction Checkin days
export const UPDATE_CHECKIN_RULE_START = 'UPDATE_CHECKIN_RULE_START';
export const UPDATE_CHECKIN_RULE_END = 'UPDATE_CHECKIN_RULE_END';
export const UPDATE_CHECKIN_RULE_ERROR = 'UPDATE_CHECKIN_RULE_ERROR';

export const GET_CHECKIN_RULE_DAYS_START = 'GET_CHECKIN_RULE_DAYS_START';
export const GET_CHECKIN_RULE_DAYS_END = 'GET_CHECKIN_RULE_DAYS_END';
export const GET_CHECKIN_RULE_DAYS_ERROR = 'GET_CHECKIN_RULE_DAYS_ERROR';

// Load User Account Data
export const MEMEBER_GENDER_START = 'MEMEBER_GENDER_START';
export const MEMEBER_GENDER_SUCCESS = 'MEMEBER_GENDER_SUCCESS';
export const MEMEBER_GENDER_ERROR = 'MEMEBER_GENDER_ERROR';

// Edit blog post
export const EDIT_BLOG_POST_START = 'EDIT_BLOG_POST_START';
export const EDIT_BLOG_POST_SUCCESS = 'EDIT_BLOG_POST_SUCCESS';
export const EDIT_BLOG_POST_ERROR = 'EDIT_BLOG_POST_ERROR';

// Add blog post
export const ADD_BLOG_POST_START = 'ADD_BLOG_POST_START';
export const ADD_BLOG_POST_SUCCESS = 'ADD_BLOG_POST_SUCCESS';
export const ADD_BLOG_POST_ERROR = 'ADD_BLOG_POST_ERROR';

// Update blog post
export const UPDATE_BLOG_POST_START = 'UPDATE_BLOG_POST_START';
export const UPDATE_BLOG_POST_SUCCESS = 'UPDATE_BLOG_POST_SUCCESS';
export const UPDATE_BLOG_POST_ERROR = 'UPDATE_BLOG_POST_ERROR';

// Subscription Modal
export const SUBSCRIPTION_MODAL_START = 'SUBSCRIPTION_MODAL_START';
export const SUBSCRIPTION_MODAL_CLOSE = 'SUBSCRIPTION_MODAL_CLOSE';

// Create social likes
export const ADD_LIKE_START = 'ADD_LIKE_START';
export const ADD_LIKE_SUCCESS = 'ADD_LIKE_SUCCESS';
export const ADD_LIKE_ERROR = 'ADD_LIKE_ERROR';

// Add or remove blog pin
export const ADD_REMOVE_BLOG_POST_PIN = 'ADD_REMOVE_BLOG_POST_PIN';
export const ADD_REMOVE_BLOG_POST_SUCCESS = 'ADD_REMOVE_BLOG_POST_SUCCESS';
export const ADD_REMOVE_BLOG_POST_ERROR = 'ADD_REMOVE_BLOG_POST_ERROR';

export const UPDATE_SOCIAL_RULES_START = 'UPDATE_SOCIAL_RULES_START';
export const UPDATE_SOCIAL_RULES_SUCCESS = 'UPDATE_SOCIAL_RULES_SUCCESS';
export const UPDATE_SOCIAL_RULES_ERROR = 'UPDATE_SOCIAL_RULES_ERROR';

// Social blog share modal
export const MANAGE_SOCIAL_BLOG_SHARE_MODAL = 'MANAGE_SOCIAL_BLOG_SHARE_MODAL';

// Delete blog comment
export const DELETE_COMMENT_START = 'DELETE_COMMENT_START';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_ERROR = 'DELETE_COMMENT_ERROR';

// Update connection details on social blog page
export const UPDATE_SOCIAL_CONNECTION_DETAILS_START =
  'UPDATE_SOCIAL_CONNECTION_DETAILS_START';
export const UPDATE_SOCIAL_CONNECTION_DETAILS_SUCCESS =
  'UPDATE_SOCIAL_CONNECTION_DETAILS_SUCCESS';
export const UPDATE_SOCIAL_CONNECTION_DETAILS_ERROR =
  'UPDATE_SOCIAL_CONNECTION_DETAILS_ERROR';

// Add event
export const EVENT_ADD_START = 'EVENT_ADD_START';
export const EVENT_ADD_SUCCESS = 'EVENT_ADD_SUCCESS';
export const EVENT_ADD_ERROR = 'EVENT_ADD_ERROR';

// Update event
export const EVENT_UPDATE_START = 'EVENT_UPDATE_START';
export const EVENT_UPDATE_SUCCESS = 'EVENT_UPDATE_SUCCESS';
export const EVENT_UPDATE_ERROR = 'EVENT_UPDATE_ERROR';

// Delete event
export const EVENT_DELETE_START = 'EVENT_DELETE_START';
export const EVENT_DELETE_SUCCESS = 'EVENT_DELETE_SUCCESS';
export const EVENT_DELETE_ERROR = 'EVENT_DELETE_ERROR';

// Get all event
export const GET_ALL_EVENT_START = 'GET_ALL_EVENT_START';
export const GET_ALL_EVENT_SUCCESS = 'GET_ALL_EVENT_SUCCESS';
export const GET_ALL_EVENT_ERROR = 'GET_ALL_EVENT_ERROR';

// Update event status in Admin side
export const UPDATE_BLOG_CONTENT_EVENT_STATUS_START =
  'UPDATE_BLOG_CONTENT_EVENT_STATUS_START';
export const UPDATE_BLOG_CONTENT_EVENT_STATUS_SUCCESS =
  'UPDATE_BLOG_CONTENT_EVENT_STATUS_SUCCESS';
export const UPDATE_BLOG_CONTENT_EVENT_STATUS_ERROR =
  'UPDATE_BLOG_CONTENT_EVENT_STATUS_ERROR';

// Natural retreats update listing
export const UPDATE_NATURAL_RETREATS_LISTING_START =
  'UPDATE_NATURAL_RETREATS_LISTING_START';
export const UPDATE_NATURAL_RETREATS_LISTING_SUCCESS =
  'UPDATE_NATURAL_RETREATS_LISTING_SUCCESS';
export const UPDATE_NATURAL_RETREATS_LISTING_ERROR =
  'UPDATE_NATURAL_RETREATS_LISTING_ERROR';

export const GET_NATURAL_RETREATS_BOOKINGS = 'GET_NATURAL_RETREATS_BOOKINGS';
export const GET_NATURAL_RETREATS_BOOKINGS_START =
  'GET_NATURAL_RETREATS_BOOKINGS_START';
export const GET_NATURAL_RETREATS_BOOKINGS_SUCCESS =
  'GET_NATURAL_RETREATS_BOOKINGS_SUCCESS';

// Natural Retreats Quote
export const SEND_NR_BOOKING_DATA_START = 'SEND_NR_BOOKING_DATA_START';
export const SEND_NR_BOOKING_DATA_SUCCESS = 'SEND_NR_BOOKING_DATA_SUCCESS';

// Event confirmation modal
export const EVENT_CONFIRMATION_MODAL_OPEN = 'EVENT_CONFIRMATION_MODAL_OPEN';
export const EVENT_CONFIRMATION_MODAL_CLOSE = 'EVENT_CONFIRMATION_MODAL_CLOSE';

// Decline reason modal
export const DECLINE_REASON_MODAL_OPEN = 'DECLINE_REASON_MODAL_OPEN';
export const DECLINE_REASON_MODAL_CLOSE = 'DECLINE_REASON_MODAL_CLOSE';

// ADMIN ROLES MODAL
export const OPEN_ADMIN_USER_MODAL = 'OPEN_ADMIN_USER_MODAL';
export const CLOSE_ADMIN_USER_MODAL = 'CLOSE_ADMIN_USER_MODAL';

// Create Admin User
export const CREATE_ADMIN_USER_START = 'CREATE_ADMIN_USER_START';
export const CREATE_ADMIN_USER_SUCCESS = 'CREATE_ADMIN_USER_SUCCESS';
export const CREATE_ADMIN_USER_ERROR = 'CREATE_ADMIN_USER_ERROR';

// Delete Admin User
export const DELETE_ADMIN_USER_START = 'DELETE_ADMIN_USER_START';
export const DELETE_ADMIN_USER_SUCCESS = 'DELETE_ADMIN_USER_SUCCESS';
export const DELETE_ADMIN_USER_ERROR = 'DELETE_ADMIN_USER_ERROR';

// ADMIN ROLES MODAL
export const OPEN_ADMIN_ROLES_MODAL = 'OPEN_ADMIN_ROLES_MODAL';
export const CLOSE_ADMIN_ROLES_MODAL = 'CLOSE_ADMIN_ROLES_MODAL';

// Create Admin Role
export const CREATE_ADMIN_ROLES_START = 'CREATE_ADMIN_ROLES_START';
export const CREATE_ADMIN_ROLES_SUCCESS = 'CREATE_ADMIN_ROLES_SUCCESS';
export const CREATE_ADMIN_ROLES_ERROR = 'CREATE_ADMIN_ROLES_ERROR';

// Delete Admin Role
export const DELETE_ADMIN_ROLES_START = 'DELETE_ADMIN_ROLES_START';
export const DELETE_ADMIN_ROLES_SUCCESS = 'DELETE_ADMIN_ROLES_SUCCESS';
export const DELETE_ADMIN_ROLES_ERROR = 'DELETE_ADMIN_ROLES_ERROR';

// Tags
export const OPEN_TAG_MODAL = 'OPEN_TAG_MODAL';
export const CLOSE_TAG_MODAL = 'CLOSE_TAG_MODAL';
export const GET_ALL_TAGS = 'GET_ALL_TAGS';

// Local Spot
export const LOCAL_SPOT_START = 'LOCAL_SPOT_START';
export const LOCAL_SPOT_SUCCESS = 'LOCAL_SPOT_SUCCESS';
export const LOCAL_SPOT_ERROR = 'LOCAL_SPOT_ERROR';

export const GET_LIST_VIDEOS = 'GET_LIST_VIDEOS';
export const UPDATE_ERROR_IN_VIDEOS = 'UPDATE_ERROR_IN_VIDEOS';

// Update Likes
export const UPDATE_LIKE_START = 'UPDATE_LIKE_START';
export const UPDATE_LIKE_SUCCESS = 'UPDATE_LIKE_SUCCESS';
export const UPDATE_LIKE_ERROR = 'UPDATE_LIKE_ERROR';

// Add blog comment
export const GET_TITLE_BLOG_START = 'GET_TITLE_BLOG_START';
export const GET_TITLE_BLOG_SUCCESS = 'GET_TITLE_BLOG_SUCCESS';
export const GET_TITLE_BLOG_ERROR = 'GET_TITLE_BLOG_ERROR';

// Social like modal
export const MANAGE_SOCIAL_LIKE_MODAL = 'MANAGE_SOCIAL_LIKE_MODAL';

// Member Delete
export const MEMEBER_DELETE_START = 'MEMEBER_DELETE_START';
export const MEMEBER_DELETE_SUCCESS = 'MEMEBER_DELETE_SUCCESS';
export const MEMEBER_DELETE_ERROR = 'MEMEBER_DELETE_ERROR';

// Notification
export const NOTIFICATION_ENABLE_START = 'NOTIFICATION_ENABLE_START';
export const NOTIFICATION_ENABLE_SUCCESS = 'NOTIFICATION_ENABLE_SUCCESS';
export const NOTIFICATION_ENABLE_ERROR = 'NOTIFICATION_ENABLE_ERROR';

export const GET_USER_NOTIFICATON_START = 'GET_USER_NOTIFICATON_START';
export const GET_USER_NOTIFICATON_SUCCESS = 'GET_USER_NOTIFICATON_SUCCESS';
export const GET_USER_NOTIFICATON_ERROR = 'GET_USER_NOTIFICATON_ERROR';

// SET_MEMBER_FORM_STATE
export const SET_MEMBER_EMAIL_FORM_STATE = 'SET_MEMBER_EMAIL_FORM_STATE';

export const UPDATE_MEMBER_DATA_START = 'UPDATE_MEMBER_DATA_START';
export const UPDATE_MEMBER_DATA_SUCCESS = 'UPDATE_MEMBER_DATA_SUCCESS';
export const UPDATE_MEMBER_DATA_ERROR = 'UPDATE_MEMBER_DATA_ERROR';

export const SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';

// NextPax

export const GET_NEXTPAX_QUOTE_START = 'GET_NEXTPAX_QUOTE_START';
export const GET_NEXTPAX_QUOTE_SUCCESS = 'GET_NEXTPAX_QUOTE_SUCCESS';

export const FETCH_NEXTPAX_PRICES_START = 'FETCH_NEXTPAX_PRICES_START';
export const FETCH_NEXTPAX_PRICES_SUCCESS = 'FETCH_NEXTPAX_PRICES_SUCCESS';
export const FETCH_NEXTPAX_CALENDARS_START = 'FETCH_NEXTPAX_CALENDARS_START';
export const FETCH_NEXTPAX_CALENDARS_SUCCESS =
  'FETCH_NEXTPAX_CALENDARS_SUCCESS';

export const GET_NEXTPAX_BOOKINGS = 'GET_NEXTPAX_BOOKINGS_ERROR';
export const GET_NEXTPAX_BOOKINGS_START = 'GET_NEXTPAX_BOOKINGS';
export const GET_NEXTPAX_BOOKINGS_SUCCESS = 'GET_NEXTPAX_BOOKINGS_SUCCESS';

export const SOICAL_NOTIFICATION_START = 'SOICAL_NOTIFICATION_START';
export const SOICAL_NOTIFICATION_SUCCESS = 'SOICAL_NOTIFICATION_SUCCESS';
export const SOICAL_NOTIFICATION_ERROR = 'SOICAL_NOTIFICATION_ERROR';

// Get phone number entry open
export const OPEN_INVITE_EMAIL_MODAL = 'OPEN_INVITE_EMAIL_MODAL';
export const CLOSE_INVITE_EMAIL_MODAL = 'CLOSE_INVITE_EMAIL_MODAL';

export const UPDATE_BOOKING_GOSOLO = 'UPDATE_BOOKING_GOSOLO';
export const CLEAR_BOOKING_GOSOLO = 'CLEAR_BOOKING_GOSOLO';

export const UPDATE_SUBSCRIPTION_FORM_MODAL = 'UPDATE_SUBSCRIPTION_FORM_MODAL';
export const UPDATE_GOSOLO_STAY_FORM_MODAL = 'UPDATE_GOSOLO_STAY_FORM_MODAL';
export const UPDATE_GOSOLO_TRIP_TYPE_FORM_MODAL =
  'UPDATE_GOSOLO_TRIP_TYPE_FORM_MODAL';

// Integration unsubscribing
export const INTEGRATION_UNSUBSCRIBING_START =
  'INTEGRATION_UNSUBSCRIBING_START';
export const INTEGRATION_UNSUBSCRIBING_SUCCESS =
  'INTEGRATION_UNSUBSCRIBING_SUCCESS';
export const INTEGRATION_UNSUBSCRIBING_ERROR =
  'INTEGRATION_UNSUBSCRIBING_ERROR';

// change merchant status
export const CHANGE_MERCHANT_STATUS_START = 'CHANGE_MERCHANT_STATUS_START';
export const CHANGE_MERCHANT_STATUS_SUCCESS = 'CHANGE_MERCHANT_STATUS_SUCCESS';
export const CHANGE_MERCHANT_STATUS_ERROR = 'CHANGE_MERCHANT_STATUS_ERROR';

// OwnerRez
export const SEND_OWNERREZ_BOOKING_DATA_START =
  'SEND_OWNERREZ_BOOKING_DATA_START';
export const SEND_OWNERREZ_BOOKING_DATA_SUCCESS =
  'SEND_OWNERREZ_BOOKING_DATA_SUCCESS';
export const SET_OWNERREZ_BOOKINGS = 'SET_OWNERREZ_BOOKINGS';

export const GET_OWNERREZ_BOOKINGS_BY_DATES_START =
  'GET_OWNERREZ_BOOKINGS_BY_DATES_START';
export const GET_OWNERREZ_BOOKINGS_BY_DATES_SUCCESS =
  'GET_OWNERREZ_BOOKINGS_BY_DATES_SUCCESS';

// InterhomeManagement
export const SEND_INTERHOME_BOOKING_DATA_START =
  'SEND_INTERHOME_BOOKING_DATA_START';
export const SEND_INTERHOME_BOOKING_DATA_SUCCESS =
  'SEND_INTERHOME_BOOKING_DATA_SUCCESS';

export const SET_INTERHOME_RESERVATION_ID = 'SET_INTERHOME_RESERVATION_ID';
export const SET_INTERHOME_PAYMENT_LOADING = 'SET_INTERHOME_PAYMENT_LOADING';
export const SET_INTERHOME_BOOKINGS = 'SET_INTERHOME_BOOKINGS';

export const SET_INTERHOME_ADMIN_LISTINGS = 'SET_INTERHOME_ADMIN_LISTINGS';
export const SET_INTERHOME_ADMIN_LISTINGS_SUCCESS =
  'SET_INTERHOME_ADMIN_LISTINGS_SUCCESS';

export const GET_INTERHOME_BOOKINGS_BY_DATES_START =
  'GET_INTERHOME_BOOKINGS_BY_DATES_START';
export const GET_INTERHOME_BOOKINGS_BY_DATES_SUCCESS =
  'GET_INTERHOME_BOOKINGS_BY_DATES_SUCCESS';

export const GET_INTERHOME_PAYMENT_STATUS_START =
  'GET_INTERHOME_PAYMENT_STATUS_START';
export const GET_INTERHOME_PAYMENT_STATUS_SUCCESS =
  'GET_INTERHOME_PAYMENT_STATUS_SUCCESS';

// Hostfully Bookings
export const GET_HOSTFULLY_BOOKINGS = 'GET_HOSTFULLY_BOOKINGS';
export const GET_HOSTFULLY_BOOKINGS_BY_DATES_START =
  'GET_HOSTFULLY_BOOKINGS_BY_DATES_START';
export const GET_HOSTFULLY_BOOKINGS_BY_DATES_SUCCESS =
  'GET_HOSTFULLY_BOOKINGS_BY_DATES_SUCCESS';

export const YOUR_LISTINGS_START = 'YOUR_LISTINGS_START';
export const YOUR_LISTINGS_SUCCESS = 'YOUR_LISTINGS_SUCCESS';
export const YOUR_LISTINGS_ERROR = 'YOUR_LISTINGS_ERROR';
export const SET_USER_TOKEN_DATA = 'SET_USER_TOKEN_DATA';

// HostAway
export const HOSTAWAY_PRICES_START = 'HOSTAWAY_PRICES_START';
export const HOSTAWAY_PRICES_SUCCESS = 'HOSTAWAY_PRICES_SUCCESS';
export const HOSTAWAY_PRICES_ERROR = 'HOSTAWAY_PRICES_ERROR';
export const SET_HOSTAWAY_BOOKINGS = 'SET_HOSTAWAY_BOOKINGS';
export const GET_HOSTAWAY_BOOKINGS_BY_DATES_START =
  'GET_HOSTAWAY_BOOKINGS_BY_DATES_START';
export const GET_HOSTAWAY_BOOKINGS_BY_DATES_SUCCESS =
  'GET_HOSTAWAY_BOOKINGS_BY_DATES_SUCCESS';

export const GET_HOSTFULLY_PRICING_RULES_START =
  'GET_HOSTFULLY_PRICING_RULES_START';
export const GET_HOSTFULLY_PRICING_RULES_SUCCESS =
  'GET_HOSTFULLY_PRICING_RULES_SUCCESS';

// HappyRentals
export const GET_HAPPY_RENTALS_PRICES_START = 'GET_HAPPY_RENTALS_PRICES_START';
export const GET_HAPPY_RENTALS_PRICES_SUCCESS =
  'GET_HAPPY_RENTALS_PRICES_SUCCESS';
export const GET_HAPPY_RENTALS_BOOKINGS_BY_DATES_START =
  'GET_HAPPY_RENTALS_BOOKINGS_BY_DATES_START';
export const GET_HAPPY_RENTALS_BOOKINGS_BY_DATES_SUCCESS =
  'GET_HAPPY_RENTALS_BOOKINGS_BY_DATES_SUCCESS';
export const SET_HAPPY_RENTALS_BOOKINGS = 'SET_HAPPY_RENTALS_BOOKINGS';

// integration listing edit cancellation

export const EDIT_LISTING_CANCELLATION_START =
  'EDIT_LISTING_CANCELLATION_START';
export const EDIT_LISTING_CANCELLATION_SUCCESS =
  'EDIT_LISTING_CANCELLATION_SUCCESS';
export const EDIT_LISTING_CANCELLATION_ERROR =
  'EDIT_LISTING_CANCELLATION_ERROR';

export const GET_EDIT_LISTING_CANCELLATION_START =
  'GET_EDIT_LISTING_CANCELLATION_START';
export const GET_EDIT_LISTING_CANCELLATION_SUCCESS =
  'GET_EDIT_LISTING_CANCELLATION_SUCCESS';

// listing overrides
export const LISTING_OVERRIDE_START = 'LISTING_OVERRIDE_START';
export const LISTING_OVERRIDE_SUCCESS = 'LISTING_OVERRIDE_SUCCESS';
export const LISTING_OVERRIDE_ERROR = 'LISTING_OVERRIDE_ERROR';

// listing update type
export const LISTING_UPDATE_TYPE_START = 'LISTING_UPDATE_TYPE_START';
export const LISTING_UPDATE_TYPE_SUCCESS = 'LISTING_UPDATE_TYPE_SUCCESS';
export const LISTING_UPDATE_TYPE_ERROR = 'LISTING_UPDATE_TYPE_ERROR';

export const OPEN_LOCAL_SPOT_SHOW_MODAL = 'OPEN_LOCAL_SPOT_SHOW_MODAL';
export const CLOSE_LOCAL_SPOT_SHOW_MODAL = 'CLOSE_LOCAL_SPOT_SHOW_MODAL';
export const UPDATE_CREDIT_FORM_MODAL = 'UPDATE_CREDIT_FORM_MODAL';
export const UPDATE_GOSOLO_USER_REQUEST_MODAL =
  'UPDATE_GOSOLO_USER_REQUEST_MODAL';

// ADMIN LOGS
export const GET_LOGS_START = 'GET_LOGS_START';
export const GET_LOGS_SUCCESS = 'GET_LOGS_SUCCESS';
export const GET_LOGS_ERROR = 'GET_LOGS_ERROR';

// LISTING PHOTOS

export const DISPLAY_LISTING_IMAGES_START = 'DISPLAY_LISTING_IMAGES_START';
export const DISPLAY_LISTING_IMAGES_SUCCESS = 'DISPLAY_LISTING_IMAGES_SUCCESS';
export const DISPLAY_LISTING_IMAGES_REMOVE = 'DISPLAY_LISTING_IMAGES_REMOVE';
export const DISPLAY_LISTING_IMAGES_HIDE = 'DISPLAY_LISTING_IMAGES_HIDE';
export const DISPLAY_LISTING_IMAGES_DESCRIPTION =
  'DISPLAY_LISTING_IMAGES_DESCRIPTION';
export const DISPLAY_LISTING_IMAGES_MODIFY = 'DISPLAY_LISTING_IMAGES_MODIFY';
export const DELETE_UPLOADED_PHOTOS = 'DELETE_UPLOADED_PHOTOS';

export const CREATE_LISTING_PHOTO_START = 'CREATE_LISTING_PHOTO_START';
export const CREATE_LISTING_PHOTO_SUCCESS = 'CREATE_LISTING_PHOTO_SUCCESS';
export const CREATE_LISTING_PHOTO_ERROR = 'CREATE_LISTING_PHOTO_ERROR';

export const REMOVE_LISTING_PHOTO_START = 'REMOVE_LISTING_PHOTO_START';
export const REMOVE_LISTING_PHOTO_SUCCESS = 'REMOVE_LISTING_PHOTO_SUCCESS';
export const REMOVE_LISTING_PHOTO_ERROR = 'REMOVE_LISTING_PHOTO_ERROR';

// GoSocial

export const REMOVE_UPLOADED_POST_IMAGE = 'REMOVE_UPLOADED_POST_IMAGE';

// Reset Password

export const UPDATE_RESET_PASSWORD_MODAL = 'UPDATE_RESET_PASSWORD_MODAL';

export const UPDATE_GO_SOLO_PRICE_SPLIT_UP_MODAL =
  'UPDATE_GO_SOLO_PRICE_SPLIT_UP_MODAL';

export const UPDATE_GOHUSTLE_INDUSTRY_FORM_MODAL =
  'UPDATE_GOHUSTLE_INDUSTRY_FORM_MODAL';

export const UPDATE_GOHUSTLE_JOB_TYPE_FORM_MODAL =
  'UPDATE_GOHUSTLE_JOB_TYPE_FORM_MODAL';

export const UPDATE_GOHUSTLE_COMMUNITY_FORM_MODAL =
  'UPDATE_GOHUSTLE_COMMUNITY_FORM_MODAL';

// Update Private Settings for GoHustle Posts
export const UPDATE_GOHUSTLE_POST_PRIVATE_STATUS_START =
  'UPDATE_GOHUSTLE_POST_PRIVATE_STATUS_START';
export const UPDATE_GOHUSTLE_POST_PRIVATE_STATUS_SUCCESS =
  'UPDATE_GOHUSTLE_POST_PRIVATE_STATUS_SUCCESS';
export const UPDATE_GOHUSTLE_POST_PRIVATE_STATUS_ERROR =
  'UPDATE_GOHUSTLE_POST_PRIVATE_STATUS_ERROR';

// Update Pin Status for GoHustle Posts
export const GOHUSTLE_POST_PIN_STATUS_START = 'GOHUSTLE_POST_PIN_STATUS_START';
export const GOHUSTLE_POST_PIN_STATUS_SUCCESS =
  'GOHUSTLE_POST_PIN_STATUS_SUCCESS';
export const GOHUSTLE_POST_PIN_STATUS_ERROR = 'GOHUSTLE_POST_PIN_STATUS_ERROR';

// Delete GoHustle Posts
export const DELETE_GOHUSTLE_POST_START = 'DELETE_GOHUSTLE_POST_START';
export const DELETE_GOHUSTLE_POST_SUCCESS = 'DELETE_GOHUSTLE_POST_SUCCESS';
export const DELETE_GOHUSTLE_POST_ERROR = 'DELETE_GOHUSTLE_POST_ERROR';

export const UPDATE_GOHUSTLE_POST_FORM_MODAL =
  'UPDATE_GOHUSTLE_POST_FORM_MODAL';
export const UPDATE_USER_CONCIERGE_MODAL = 'UPDATE_USER_CONCIERGE_MODAL';
export const UPDATE_USER_GOTEAM_MODAL = 'UPDATE_USER_GOTEAM_MODAL';
export const UPDATE_GOHUSTLE_APPLY_MODAL = 'UPDATE_GOHUSTLE_APPLY_MODAL';

export const UPDATE_APPLIED_JOBS_MODAL = 'UPDATE_APPLIED_JOBS_MODAL';

export const UPDATE_LIST_TRANSFER_MODAL = 'UPDATE_LIST_TRANSFER_MODAL';
// Create Booking Users Log
export const CREATE_BOOKING_USERS_LOG_START = 'CREATE_BOOKING_USERS_LOG_START';
export const CREATE_BOOKING_USERS_LOG_SUCCESS =
  'CREATE_BOOKING_USERS_LOG_SUCCESS';
export const CREATE_BOOKING_USERS_LOG_ERROR = 'CREATE_BOOKING_USERS_LOG_ERROR';

export const UPDATE_MAP_DATA = "UPDATE_MAP_DATA";
